import type { SpinnerProps } from '../../types/spinner.type.ts';

export function GradientSpinner({ size = 40, className = '' }: SpinnerProps) {
  return <div
    style={{
      width: size,
      height: size,
      background: 'conic-gradient(from 0deg, transparent 0%, white 100%)',
      mask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px))',
      WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px))',
    }}
    className={`animate-spin rounded-full ${className}`}
    role="status"
    aria-label="로딩 중"
  />
}